<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h5>Consulta de Usuarios Activos</h5>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">Nombre</th>
                                    <th scope="col">Correo Electrónico</th>
                                    <th scope="col">Teléfono</th>
                                    <th scope="col">Perfil</th>
                                    <th scope="col">Fecha de Alta</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let user of user_list">
                                    <td>{{ user.displayName || user.firstName + ' ' + user.lastName }}</td>
                                    <td>{{ user.email }}</td>
                                    <td>{{ user.phoneNumber }}</td>
                                    <td>{{ user.roles }}</td>
                                    <td>{{ user.created_at | date:'mediumDate' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>